import { gql } from "@apollo/client";

export const EASTER_EGG_POLL_SUBSCRIPTION = gql`
    subscription EasterEggPoll {
        easterEggPoll {
            egg {
                id
                name
                image
                successMessage
            }
            token
            message
        }
    }
`;
